export default __webpack_public_path__ + "static/media/claud.827c8dc0.jpg";